import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from 'react-bootstrap';
import './sanctionOrderModal.css';

const formatDate = (value) => {
    if (!value) return '—';
    const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    return match ? `${match[3]}-${match[2]}-${match[1]}` : value;
};

const formatAmount = (value) => {
    if (value === null || value === undefined || value === '') return '—';
    const amount = Number(value);
    if (Number.isNaN(amount)) return value;
    return amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const InfoItem = ({ label, value }) => (
    <div className="so-info-item">
        <div className="so-info-label">{label}</div>
        <div className="so-info-value">{value || '—'}</div>
    </div>
);

const AddBudgetPreview = ({
    showPreview,
    setShowPreview,
    formData,
    handleSubmit,
    isSubmitting = false,
    schemes,
    subheadsList,
    financialYears,
    total_scheme_budget,
    total_provisional_budget,
    activity,
    subActivity,
    requireActivity = false,
}) => {
    const handleClose = () => setShowPreview(false);

    const findById = (list, id) => {
        if (!id || !Array.isArray(list)) return null;
        return list.find((item) => String(item.id) === String(id)) || null;
    };

    const scheme = findById(schemes, formData.scheme_id);
    const financialYear = findById(financialYears, formData.financial_year);
    const yearLabel = financialYear
        ? `${financialYear.start_year}-${financialYear.end_year}`
        : '';

    const activityName = (id) => findById(activity, id)?.activity || '';
    const subactivityName = (activityId, subactivityId) => {
        if (!activityId || !subactivityId || !Array.isArray(subActivity)) return '';
        const match = subActivity.find(
            (item) => String(item.id) === String(subactivityId)
                && String(item.activity_id) === String(activityId)
        );
        return match?.subactivity || '';
    };

    const ActivityRows = ({ rows }) => {
        const list = Array.isArray(rows) ? rows : [];
        if (!list.length) {
            return <div className="so-info-value">Activity and Subactivity are not selected.</div>;
        }
        return (
            <div className="table-responsive">
                <table className="table table-sm table-bordered add-budget-activity-table mb-0">
                    <thead>
                        <tr>
                            <th>Activity</th>
                            <th>Subactivity</th>
                            <th>Provisional Budget</th>
                            <th>Released Budget</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((row, index) => (
                            <tr key={`${row.activity_id || 'activity'}-${row.subactivity_id || 'sub'}-${index}`}>
                                <td>{activityName(row.activity_id) || 'Not selected'}</td>
                                <td>{subactivityName(row.activity_id, row.subactivity_id) || 'Not selected'}</td>
                                <td>{formatAmount(row.provisional_budget)}</td>
                                <td>{formatAmount(row.budget)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    const SubheadCards = ({ title, rows, isNew = false }) => {
        if (!rows?.length) return null;
        return (
            <div className="so-block">
                <div className="so-block-title-row">
                    <h6 className="so-block-title">{title}</h6>
                    <span className="so-soft-badge">{rows.length}</span>
                </div>
                {rows.map((subhead, index) => {
                    const details = isNew ? null : findById(subheadsList, subhead.id);
                    return (
                        <div className="so-invoice-card" key={`${isNew ? 'new' : 'sub'}-${subhead.id || subhead.code || index}`}>
                            <div className="so-invoice-head">
                                <strong>{index + 1}. {isNew ? (subhead.name || '—') : (details?.name || '—')}</strong>
                                <span>{isNew ? (subhead.code || '—') : (details?.code || '—')}</span>
                            </div>
                            <Row className="g-2">
                                <Col xs={6} md={4}>
                                    <InfoItem label="Budget Date" value={formatDate(subhead.budget_date)} />
                                </Col>
                                <Col xs={6} md={4}>
                                    <InfoItem label="Provisional Budget" value={formatAmount(subhead.provisional_budget)} />
                                </Col>
                                <Col xs={6} md={4}>
                                    <InfoItem label="Released Budget" value={formatAmount(subhead.budget)} />
                                </Col>
                            </Row>
                            {requireActivity && (
                                <div className="mt-2">
                                    <div className="so-subtitle">Activity / Subactivity</div>
                                    <ActivityRows rows={subhead.activity} />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <Modal
            dialogClassName="so-preview-modal add-budget-preview-dialog"
            show={showPreview}
            onHide={handleClose}
            centered
        >
            <Modal.Header closeButton className="so-preview-header">
                <Modal.Title>Budget Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body className="so-preview-body add-budget-preview-body">
                <div className="so-block">
                    <div className="so-block-title-row">
                        <h6 className="so-block-title">Scheme</h6>
                    </div>
                    <Row className="g-2">
                        <Col xs={12} md={6}>
                            <InfoItem label="Scheme Name" value={scheme?.name} />
                        </Col>
                        <Col xs={6} md={3}>
                            <InfoItem label="Scheme Code" value={scheme?.code} />
                        </Col>
                        <Col xs={6} md={3}>
                            <InfoItem label="Financial Year" value={yearLabel} />
                        </Col>
                        <Col xs={6} md={3}>
                            <InfoItem label="Document" value={formData.attachment?.length ? 'Uploaded' : 'Not uploaded'} />
                        </Col>
                        <Col xs={6} md={4}>
                            <InfoItem label="Total Provisional Budget" value={formatAmount(total_provisional_budget?.current)} />
                        </Col>
                        <Col xs={6} md={5}>
                            <InfoItem label="Total Released Budget" value={formatAmount(total_scheme_budget?.current)} />
                        </Col>
                    </Row>
                </div>
                <SubheadCards title="Sub Head List" rows={formData.sub_heads} />
                <SubheadCards title="New Sub Head List" rows={formData.newSub_heads} isNew />
            </Modal.Body>
            <Modal.Footer className="so-preview-footer">
                <Button variant="danger" onClick={handleClose} disabled={isSubmitting}>
                    Change
                </Button>
                <Button variant="primary" className="so-preview-submit" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'SUBMITTING...' : 'SUBMIT'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddBudgetPreview;
